import ListOfChats from "./ListOfChats";

export default ListOfChats; 